// extracted by mini-css-extract-plugin
export var dropdown = "_tm-0";
export var imageWrapper = "_tm-3";
export var itemNameContainer = "_tm-1";
export var productImage = "_tm-2";
export var spinnerWrapper = "_tm-4";